// extracted by mini-css-extract-plugin
export var arrow = "ArrowButton-module--arrow--6d937";
export var backButton = "ArrowButton-module--backButton--7e459";
export var content = "ArrowButton-module--content--e0de2";
export var decor = "ArrowButton-module--decor--e4b2a";
export var hamburger = "ArrowButton-module--hamburger--b6d51";
export var nextButton = "ArrowButton-module--nextButton--dc32e";
export var position = "ArrowButton-module--position--9fbc9";
export var reactCalendarMonthViewDays = "ArrowButton-module--react-calendar__month-view__days--a2fc3";
export var reactCalendarTile = "ArrowButton-module--react-calendar__tile--6004d";
export var reactCalendarTileActive = "ArrowButton-module--react-calendar__tile--active--ac16f";
export var relativeWrapper = "ArrowButton-module--relativeWrapper--4782a";
export var small = "ArrowButton-module--small--5c049";
export var units = "ArrowButton-module--units--de60b";